/**
 * Update date: 2024-04-17
 * Screen 2052.B
 */
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import ArrayStore from 'devextreme/data/array_store';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useState } from 'react';

const List = React.lazy(() => import('./List'));
const ViewEditCreate = React.lazy(() => import('./ViewEditCreate'));
/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2052_B_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const M2052_B = () => {
  const { t }: any = useDictionary({ programId: '2052.B' });
  const [data, setData] = useState([]);
  const [formSearchData, setFormSearchData] = useState<any>({
    dataList: {
      eslDesign: [],
      largeCategory: [],
      mediumCategory: [],
      smallCategory: [],
      subCategory: [],
      productGroup: [],
      product: [],
    },
    eslDesign: '',
    largeCategory: '',
    mediumCategory: '',
    smallCategory: '',
    subCategory: '',
    productGroup: '',
    product: '',
  });
  const [modeView, setModeView] = useState({
    type: 'list',
    isFresh: false,
  });

  const store: any = new ArrayStore({
    data: data,
    key: ['eslBarcode', 'seqNo'],
  });

  const value: any = {
    t,
    store,
    setData,
    modeView,
    setModeView,
    formSearchData,
    setFormSearchData,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
        return <ViewEditCreate />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2052_B;
